"use strict";
// ========================================
// API Response and Contract Schemas
// ========================================
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorResponseSchema = exports.baseErrorResponseSchema = exports.messageResponseSchema = exports.listResponseSchema = exports.dataResponseSchema = exports.baseSuccessResponseSchema = exports.apiTimestampSchema = void 0;
const zod_1 = require("zod");
const error_codes_1 = require("../../constants/error-codes");
const timestamp_schemas_1 = require("./timestamp.schemas");
/**
 * Canonical API timestamp schema (ISO-8601 string)
 */
exports.apiTimestampSchema = timestamp_schemas_1.timestampIsoSchema;
// ========================================
// BASE RESPONSE SCHEMAS
// ========================================
/**
 * Base success response structure (common fields only)
 */
exports.baseSuccessResponseSchema = zod_1.z.object({
    success: zod_1.z.literal(true),
    timestamp: exports.apiTimestampSchema,
    requestId: zod_1.z.string(),
});
/**
 * Success response with data only (no message allowed)
 */
const dataResponseSchema = (dataSchema) => exports.baseSuccessResponseSchema.extend({
    data: dataSchema,
});
exports.dataResponseSchema = dataResponseSchema;
/**
 * Paginated list response with cursor-based pagination
 */
const listResponseSchema = (itemSchema) => exports.baseSuccessResponseSchema.extend({
    data: zod_1.z.array(itemSchema),
    pagination: zod_1.z.object({
        nextCursor: zod_1.z.string().nullable(),
        hasMore: zod_1.z.boolean(),
        total: zod_1.z.number().int().min(0).optional(),
    }),
});
exports.listResponseSchema = listResponseSchema;
/**
 * Success response with message only (no data allowed)
 */
exports.messageResponseSchema = exports.baseSuccessResponseSchema.extend({
    message: zod_1.z.string(),
});
/**
 * Error details structure - minimal fields for frontend
 * Backend may send more fields, but we only type what frontend uses
 */
const errorDetailsSchema = zod_1.z
    .array(zod_1.z.object({
    message: zod_1.z.string(),
    path: zod_1.z.array(zod_1.z.union([zod_1.z.string(), zod_1.z.number()])),
}))
    .optional();
/**
 * Base error response structure
 */
exports.baseErrorResponseSchema = zod_1.z.object({
    success: zod_1.z.literal(false),
    error: zod_1.z.object({
        code: zod_1.z.nativeEnum(error_codes_1.ErrorCode),
        message: zod_1.z.string(),
        details: errorDetailsSchema.optional(),
    }),
    timestamp: exports.apiTimestampSchema,
    requestId: zod_1.z.string(),
});
/**
 * Create error response schema for specific error code
 * Used in contracts for API documentation
 */
const errorResponseSchema = (errorCode, message) => exports.baseErrorResponseSchema.extend({
    error: zod_1.z.object({
        code: zod_1.z.literal(errorCode),
        message: message ? zod_1.z.literal(message) : zod_1.z.string(),
        details: errorDetailsSchema.optional(),
    }),
});
exports.errorResponseSchema = errorResponseSchema;
